import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineModeService {

  public dataInRfidOfflineBs : BehaviorSubject<any>;
  public dataInRfidOfflineOBS : Observable<any>;

  constructor(public httpService: HttpService) {
    this.dataInRfidOfflineBs = new BehaviorSubject(undefined);
    this.dataInRfidOfflineOBS = this.dataInRfidOfflineBs.asObservable();
   }

  /**
 * to get item information while renew
 * @param rfidResp rfid response
 * @param callback call back request
 */
  setOfflineTxnProcess(rfidResp, callback: (data) => void) {
    // let url = environment.service_url + "/api/item/rfid/info";
    let url = environment.service_url + "/api/offline/offlineTxnProcess";
    let requestParams = new Map();
    this.httpService.post(url, rfidResp, requestParams, (resp) => {
      callback(resp);
    }, (error) => {
      console.log(error);
    });
  }


  getDataOfOflineFromRfid(obj) {
    this.dataInRfidOfflineBs.next(obj);
  }
}
